import en from './locals/en/translation.json';
import fr from './locals/fr/translation.json';

export default { en, fr };
